import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export const field =
  "w-full border border-ink/15 bg-white px-3.5 py-2.5 font-body text-sm text-ink outline-none transition-colors focus:border-ink";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try { await login(email, password); } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#EDECE9] px-6">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm bg-paper p-10 shadow-[0_30px_80px_-40px_rgba(44,42,40,0.35)]">
        <p className="overline text-clay">Studio admin</p>
        <h1 className="mt-3 font-display text-4xl font-extralight tracking-tight text-ink">Sign in</h1>
        <label className="mt-8 block">
          <span className="overline mb-2 block text-[0.6rem] text-muted">Email</span>
          <input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={field} />
        </label>
        <label className="mt-5 block">
          <span className="overline mb-2 block text-[0.6rem] text-muted">Password</span>
          <input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={field} />
        </label>
        {error && <p role="alert" data-testid="admin-login-error" className="mt-4 font-body text-sm text-red-700">{error}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className="mt-8 w-full bg-ink py-3.5 text-paper transition-colors hover:bg-ink/85 disabled:opacity-50">
          <span className="overline">{busy ? "Signing in…" : "Sign in"}</span>
        </button>
        <p className="mt-5 font-body text-xs leading-relaxed text-muted">No account? Ask the studio owner to add you.</p>
      </form>
    </main>
  );
}
